import RequestAbstract from "../abstract";

export default class PublicTgUnknownChats extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/public-tg-unknown-chats";
    }

}
